;(function (angular, _, kiloMoneyCompute) {
  'use strict'

  class TotalContainerController {

    get kmc () {
      switch (this.model) {
        case 'invoice':
          return new kiloMoneyCompute.Invoice(this.element)
        case 'quote':
          return new kiloMoneyCompute.Quote(this.element)
        case 'creditNote':
          return new kiloMoneyCompute.CreditNote(this.element)
        default:
          console.error(`Unhandled model ${this.model}`)
      }
    }

    constructor (
      // Angular
      $scope, $state, $timeout,
      // Libs
      $uibModal,
      // Managers
      InvoiceLineManager,
      // Services
      SnackService
      // Const
      // Resolved
    ) {
      // injected binding
      this.scope = $scope
      this.$state = $state
      this.timeout = $timeout
      this.uibModal = $uibModal
      this.snackService = SnackService
      this.InvoiceLineManager = InvoiceLineManager
      // Resolve for autocomplete
      this.element = {}
      this.model = 'invoice'
      this.editable = false
      this.admin = false
      // local attributes
      this.inited = false
      this.vats = []
      this.reverseVATSInfo = []
      this.subcontractInfos = []
      this.lines = []
      this.entityInfos = []
      this._notificationTimeout = undefined
    }

    $onInit () {
      this.inited = true
      if (!this.model) this.model = 'invoice'
      this._detectChanges()
      this.scope.$watch(() => this.element.lines, (newValue, oldValue) => {
        this._detectChanges()
        this._detectDepositLine()
      }, true)
    }

    _detectChanges () {
      this.vats = this._getVATs() || []
      this.reverseVATSInfo = this._getReverseChargeVAT() || []
      this.subcontractInfos = this.element.subcontractorsInfos || []
      this.directPaymentInfos = this.element.directPaymentInfos || []
      this.entityInfos = this.subcontractInfos.reduce((acc, subcontractInfo) => {
        const directPayment = this.directPaymentInfos.find(({ entity }) => entity._id === subcontractInfo.entity._id)
        return [...acc, { entity: subcontractInfo.entity, subcontract: subcontractInfo, directPayment }]
      }, [])
    }

    getLineDiscount () {
      return this.kmc.getLineDiscount()
    }

    getPayment () {
      const ele = _.get(this.element, 'payments', [])
      return ele.filter(el => !el.invoiceRef)
    }

    getDeposit () {
      const ele = _.get(this.element, 'payments', [])
      return ele.filter(el => el.invoiceRef)
    }

    adjustment() {
      this.element.lines.forEach(line => {
        line.adjustment = !line.grant ? this.element.adjustment : 0
      })
      this._detectChanges()
      this._detectDepositLine()
    }
    addGlobalDiscount () {
      return this.uibModal.open({
        size: 'lg',
        templateUrl: '/app/modules/invoice/show/templates/add-global-discount-modal.template.html',
        resolve: {
          discount: [() => {
            return angular.copy(_.get(this.element, 'globalDiscount'))
          }]
        },
        controller: ['discount', function (discount) {
          var self = this
          self.$onInit = () => {
            _.extend(self, {
              discount: discount,
              resetDiscount: resetDiscount
            })
          }

          function resetDiscount () {
            self.discount.amount = 0
          }
        }],
        controllerAs: 'ctrl'
      }).result.then((discount) => {
        if (this.form?.globalDiscount) {
          this.form.globalDiscount.$setDirty()
        }
        this.element.globalDiscount = discount
        this._detectChanges()
        this._detectDepositLine()
      })
    }

    removeGlobalDiscount () {
      this.element.globalDiscount = null
      if (this.form?.globalDiscount) {
        this.form.globalDiscount.$setDirty()
      }
      this._detectChanges()
      this._detectDepositLine()
    }

    getTotalWithPayment () {
      let total = 0
      this.element.payments.forEach((el) => {
        total += el.amount.amount
      })
      return this.element.fullTotal - total
    }

    removeDeposit () {
      this.element.depositLines = []
      this.element.depositTotal = 0
      this.element.depositPrecent = 0
      this.element.depositPrice = 0
      this.element.save().then(() => {
        this.$state.reload()
      })
    }

    isCreditNote () {
      return (this.model || '').toLowerCase() === 'creditnote'
    }

    _getVATs () {
      if (!Object.keys(this.element).length) {
        return []
      }
      return this.element.getVatInfos()
    }

    _getReverseChargeVAT () {
      return this.kmc.getReverseChargedVATInfos()
    }

    _removeGlobalDiscountIfNeeded () {
      if (_.get(this.element, 'globalDiscount') && !this.kmc.hasSingleVAT()) {
        this.element.globalDiscount = null
        if (this._notificationTimeout) {
          this.timeout.cancel(this._notificationTimeout)
        }
        this._notificationTimeout = this.timeout(function () {
          this.snackService.snack({
            text: 'La remise globale a été supprimée car la facture contient plusieurs TVA différentes',
            delay: 5000
          })
          this._notificationTimeout = null
        })
      }
    }

    addDepositLines () {
      return this.uibModal.open({
        controllerAs: 'toDeposit',
        bindToController: true,
        resolve: {
          invoice: {
            percent: true,
            amount: false,
            price: 0,
            total: 8000,
            label: this.element.title,
            number: this.element.numberFormat,
            isDeposit: true
          },
          quote: this.element,
          isDeposit: true
        },
        templateUrl: '/app/modules/quote/show/templates/to-deposit.template.html',
        controller: 'ToDepositController'
      }).result.then((result) => {
        this.element.depositPercent = result.percent
        this.element.depositPrice = result.price
        this._detectChanges()
        this._detectDepositLine()
      })
    }

    _detectDepositLine () {
      if (this.model === 'quote' && _.get(this.element, 'depositPrice', 0) > 0) {
        if (!this.element.depositPrice) {
          this.element.depositPrice = 0
        }
        this.element.depositLines = []
        this.element.depositTotal = 0
        const lines = []
        _.get(this.element, 'lines', []).forEach((el, i) => {
          if (el.type === 'simple_line') {
            const index = lines.findIndex((element) => element.VAT === el.VAT)
            if (index >= 0) {
              lines[index].price.amount = Math.round(lines[index].price.amount + ((this.priceToPercent(this.element) / 100) * el._computed ? el._computed.globalDiscounted : el.computed.globalDiscounted))
              lines[index].shouldRecompute = true
            } else {
              lines.push(this.InvoiceLineManager.create({
                price: {
                  currency: 'EUR',
                  amount: Math.round((this.priceToPercent(this.element) / 100) * el._computed ? el._computed.globalDiscounted : el.computed.globalDiscounted)
                },
                label: 'acompte sur devis n°' + this.element.number + ' (TVA ' + el.VAT + '%)',
                VAT: el.VAT,
                quantity: 1,
                type: 'simple_line',
                unit: 'u'
              }))
            }
          } else {
            lines.push(el)
          }
        })
        this.element.depositLines = lines
        /* lines.forEach((el) => {
          this.element.depositTotal += _.get(el, 'computed.fullTotal', 0)
        }) */
        this.element.depositTotal = (this.priceToPercent(this.element) / 100) * _.get(this.element, 'computed.fullTotal', 0)
      }
    }
    toPercent (quote) {
      return Number(((quote.depositPrice || 0) * 100) / quote.computed.fullTotal)
    }

    priceToPercent (quote) {
      if (!quote.depositPercent) {
        return this.toPercent(quote)
      } else {
        return quote.depositPrice
      }
    }
  }

  TotalContainerController.$inject = [
    // Angular
    '$scope', '$state', '$timeout',
    // Libs
    '$uibModal',
    // Managers
    'InvoiceLineManager',
    // Services
    'SnackService'
    // Const
    // Resolved
  ]
  angular.module('kilo.common.components')
    .component('totalContainer', {
      bindings: {
        admin: '<',
        editable: '<',
        element: '<',
        model: '@',
        form: '='
      },
      controller: TotalContainerController,
      templateUrl: '/app/common/components/total-container/total-container.template.html'
    })
})(window.angular, window._, window.kiloMoneyCompute)
